import { render } from "./HistoryCustomer.vue?vue&type=template&id=11b9e82b&scoped=true&ts=true"
import script from "./HistoryCustomer.vue?vue&type=script&lang=ts"
export * from "./HistoryCustomer.vue?vue&type=script&lang=ts"

import "./HistoryCustomer.vue?vue&type=style&index=0&id=11b9e82b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11b9e82b"]])

export default __exports__